export const getTrimValueFromHTMLString = (value: string) => {
  const plainText = value.replace(/<\/?[^>]+(>|$)/g, " ");
  if (plainText.trim() === "") {
    return plainText;
  } else {
    return value;
  }
};
